import PortalPrograms from '@classes/Programs'
import PortalRegistrations from '@classes/Registrations'
import Badge from '@components/Badge'
import Collapse from '@components/Collapse'
import DateRangePicker from '@components/DatepickerAdvanced/DateRangePicker'
import { StoreProps } from '@interfaces/StoreState'
import RecordingsTable from '@layouts/MyMedia/RecordingsTable'
import { DATE_FORMAT, VIRTUAL_CLASSROOM_PROVIDER } from '@utils/constants'
import moment, { Moment } from 'moment'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Name } from './style'

const MediaPanel: React.FC<{ programId: string; active: boolean }> = ({ programId, active }) => {
  const StudentProgram = useSelector(({ userProfile }: StoreProps) =>
    new PortalPrograms(userProfile?.info?.StudentProfile?.StudentProfileInfo?.ProgramStudentWrappers ?? []).getProgram(
      programId
    )
  )

  const StudentRegistration = useSelector(({ userProfile }: StoreProps) =>
    new PortalRegistrations(
      userProfile?.info?.StudentProfile?.StudentProfileInfo?.RegistrationWrappers ?? []
    ).getRegistration(programId)
  )

  const [open, setOpen] = useState(active)
  const label = StudentProgram.isFlexProgram() ? 'Flex' : 'Live Online'
  const { ProgramName, ProgramEnrollDate, ContractEndDate } = StudentProgram.program || {}
  const { DisplayName } = StudentRegistration.registration || {}
  const minDate = moment(ProgramEnrollDate, DATE_FORMAT.TZ)
  const maxDate = moment(ContractEndDate, DATE_FORMAT.BASIC)
  const [startDate, setStartDate] = useState<Moment | null>(minDate.startOf('day'))
  const [endDate, setEndDate] = useState<Moment | null>(maxDate.endOf('day'))
  const [focusedInput, setFocusedInput] = useState<'startDate' | 'endDate' | null>(null)
  const numberOfMonths = window && window.innerWidth < 700 ? 1 : 2
  const provider = StudentProgram.ClassroomProvider
  const roomId = programId
  const badgeLabel = `${StudentProgram.isChildProgram() ? 'Extra lessons - ' : ''}${label}`
  return (
    <Collapse.Panel
      id={programId}
      onClick={(panelActive) => {
        setOpen(panelActive)
      }}
      header={
        <>
          <Name>{DisplayName || ProgramName}</Name>{' '}
          {!!badgeLabel && <Badge className="badge__panel" color={open ? 'default' : 'purple'} label={badgeLabel} />}
        </>
      }
    >
      <Collapse.Section grayed>
        <DateRangePicker
          minDate={minDate}
          maxDate={maxDate}
          startDate={startDate}
          endDate={endDate}
          onDatesChange={(dates) => {
            setStartDate(dates.startDate)
            setEndDate(dates.endDate)
          }}
          endDateId="1"
          startDateId="2"
          focusedInput={focusedInput}
          onFocusChange={(input) => {
            setFocusedInput(input)
          }}
          isOutsideRange={() => false}
          numberOfMonths={numberOfMonths}
          firstDayOfWeek={0}
          hideKeyboardShortcutsPanel
          displayFormat={DATE_FORMAT.NORMAL}
          readOnly
        />
      </Collapse.Section>
      <Collapse.Section>
        <RecordingsTable
          roomId={roomId}
          provider={provider}
          startDate={startDate?.startOf('day')?.unix()}
          endDate={endDate?.endOf('day')?.unix()}
        />
      </Collapse.Section>
    </Collapse.Panel>
  )
}

export default MediaPanel
